import { AutomatorWorkflowElementVariable } from '@graphql';
import { WorkflowElementVariableView } from '@workflow/models/view-model';

/**
 * Converts AutomatorWorkflowElementVariable array to WorkflowElementVariableView array
 * by adding the required fieldNameLabel and objectNameLabel properties
 */
export function mapToWorkflowElementVariableView(
  variables: AutomatorWorkflowElementVariable[]
): WorkflowElementVariableView[] {
  return variables.map(variable => ({
    ...variable,
    fieldNameLabel: variable.referredFieldName || variable.originFieldName || variable.id || '',
    objectNameLabel: variable.referredObjectName || variable.originObjectName || ''
  }));
}

/**
 * Converts a single AutomatorWorkflowElementVariable to WorkflowElementVariableView
 */
export function mapSingleToWorkflowElementVariableView(
  variable: AutomatorWorkflowElementVariable
): WorkflowElementVariableView {
  return {
    ...variable,
    fieldNameLabel: variable.referredFieldName || variable.originFieldName || variable.id || '',
    objectNameLabel: variable.referredObjectName || variable.originObjectName || ''
  };
}
